import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { NotificationReportPage } from "../../../components/notifications/NotificationReportPage";
import { useI18n } from "../../../lib/i18n";

export const Route = createFileRoute("/workspace/users/$userId/notification-report")({
  component: UserNotificationReportRoute,
});

function UserNotificationReportRoute() {
  const { userId } = Route.useParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  return (
    <NotificationReportPage
      userId={userId}
      backLabel={t("pro.notifications.report.backToUser")}
      onBack={() => navigate({ to: "/workspace/users/$userId", params: { userId } })}
    />
  );
}
